import React, { useState, useEffect, useCallback } from 'react';
import { functions } from './firebase';
import { httpsCallable } from 'firebase/functions';
import { QRCodeSVG } from 'qrcode.react';

const listManagedGatesForAdmin = httpsCallable(functions, 'listManagedGatesForAdminV2');

const ManagedGatesDashboard = ({ user, onManageAccess }) => {
    const [gates, setGates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [qrCodeModalOpen, setQrCodeModalOpen] = useState(false);
    const [selectedGate, setSelectedGate] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchManagedGates = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await listManagedGatesForAdmin();
            setGates(result.data.gates);
        } catch (err) {
            console.error("Error fetching managed gates:", err);
            setError("Kunne ikke hente administrerte porter. Vennligst prøv igjen senere.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchManagedGates();
    }, [fetchManagedGates]);

    const handleShowQrCode = (gate) => {
        setSelectedGate(gate);
        setQrCodeModalOpen(true);
    };

    const handleCloseQrCodeModal = () => {
        setQrCodeModalOpen(false);
        setSelectedGate(null);
    };

    if (loading) {
        return <div style={{ padding: '20px' }}>Laster porter...</div>;
    }

    if (error) {
        return <div style={{ padding: '20px', color: 'red' }}>{error}</div>;
    }

    return (
        <div>
            <h3>Mine Porter</h3>
            <p>
                Dette er en oversikt over alle portene du har blitt tildelt ansvaret for.
            </p>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                <thead>
                    <tr>
                        <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Portnavn</th>
                        {!isMobile && <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Tilkoblet Enhet</th>}
                        <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'right', width: '1%', whiteSpace: 'nowrap' }}>Handlinger</th>
                    </tr>
                </thead>
                <tbody>
                    {gates.length > 0 ? gates.map((gate) => (
                        <tr key={gate.id}>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{gate.name}</td>
                            {!isMobile && <td style={{ border: '1px solid #ddd', padding: '8px' }}>{gate.assignedDeviceId || 'Ikke tilkoblet'}</td>}
                            <td style={{ border: '1px solid #ddd', padding: '8px', width: '1%', whiteSpace: 'nowrap' }}>
                                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                    <button
                                        onClick={() => onManageAccess(gate)}
                                    >
                                        Administrer
                                    </button>
                                    <button
                                        onClick={() => handleShowQrCode(gate)}
                                        disabled={!gate.assignedDeviceId}
                                    >
                                        QR-kode
                                    </button>
                                </div>
                            </td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={isMobile ? 2 : 3} style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                                Du administrerer ingen porter for øyeblikket.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {qrCodeModalOpen && (
                 <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                    <div style={{ background: 'var(--background-light)', color: 'var(--text-light)', padding: '20px', borderRadius: '5px', display: 'flex', flexDirection: 'column', gap: '15px', maxWidth: '90%', maxHeight: '90vh', overflowY: 'auto' }}>
                         <h4>QR-kode for {selectedGate?.name}</h4>
                         <div style={{ padding: '20px', background: 'white', display: 'inline-block', margin: '0 auto' }}>
                             <QRCodeSVG
                                 value={`https://bifrostkey.com/request-access?gateId=${selectedGate?.id}`}
                                 size={256}
                             />
                         </div>
                         <p style={{ textAlign: 'center', fontSize: '0.8em', color: 'var(--text-dark)' }}>
                             Port ID: {selectedGate?.id}
                         </p>
                         <button onClick={handleCloseQrCodeModal} style={{ alignSelf: 'center' }}>Lukk</button>
                     </div>
                 </div>
            )}
        </div>
    );
};

export default ManagedGatesDashboard;
